import Api from './Api';

const END_POINT = 'services';

export default {
    async get_all(filters = null) {        
        let request = {
            params: filters
        }
        return await Api.get(`${END_POINT}`, request);
    },
    async get_allPaginated(filters = null) {
        let request = {
            params: filters
        }
        return await Api.get(`${END_POINT}-list-paginated`, request);
    },
    async store(service) {
        return await Api.post(`${END_POINT}`, service);
    },
    async update(service) {
        return await Api.patch(`${END_POINT}/${service.id}`, service);
    },
    async change_status(service) {
        return await Api.patch(`${END_POINT}/${service.id}/change-status`, service);
    },
    async delete(service) {
        return await Api.delete(`${END_POINT}/${service.id}`, service);
    },
}